<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <strong>{{$t('sidebars.addOrder')}}</strong>
              </CCol>
              <CCol  style="text-align: end;">
                <!--                <CButton @click="AddAllRefer()" size="sm" color="primary">-->
                <!--                  {{ $t('components.referSelected') }}-->
                <!--                </CButton>-->
              </CCol>

            </CRow>
            <CRow>
              <CCol col="3">
                <date-picker
                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>

            </CRow>

          </CCardHeader>
          <CCardBody>


            <CDataTable
                :items="items_buy"
                :fields="fields"
                column-filter
                :items-per-page="20"
                hover
                @row-clicked="table_row_clicked"

                sorter
                pagination
            >
              <template #row="{item,index}">

                <td>
                  <p >{{ index + 1 }}</p>

                </td>

              </template>

              <template #createdAt="{item}">

                <td>
                  {{ get_date(item.createdAt) }}

                </td>


              </template>

              <template #price="{item}">

                <td>
                  <p  style="float: right" >{{ get_currency(get_total_price(item)) }}</p>
                </td>


              </template>

              <template #select-header="{item}">
                <input type="checkbox" v-model="check_all_exit"
                />
              </template>
              <template #select="{item}">
                <td>
                  <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                         :value="item.masterId"/>
                </td>
              </template>


            </CDataTable>

          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

    <CModal
        :show.sync="show_factor_detail"
        :no-close-on-backdrop="true"
        :centered="true"
        :title="$t('requestDetail')"
        size="lg"
        color="dark"
    >
      <CDataTable
          :items="selected_factor"
          :fields="factor_product_fields"
          column-filter
          :items-per-page="200"
          hover
          sorter
          pagination
      >
        <template #row="{item,index}">
          <td>
            <p style="text-align: center">{{ index + 1 }}</p>
          </td>
        </template>
        <template #qty="{item}">
          <td>
            <p style="text-align: center">{{ (item.qty) }}</p>
          </td>
        </template>
        <template #vat="{item}">
          <td>
            <p style="text-align: right">{{ get_currency(item.vat) }}</p>
          </td>
        </template>
        <template #discount="{item}">
          <td>
            <p style="text-align: right">{{ get_currency(item.discount) }}</p>
          </td>
        </template>
        <template #price="{item}">
          <td>
            <p style="text-align: right">{{ get_currency(item.price) }}</p>
          </td>
        </template>

      </CDataTable>

      <template #footer>
        <CButton @click="accept_factor"

                 color="secondary"
        >{{$t('sendOrder')}}
        </CButton>
        <CButton
            @click="show_factor_detail = false"
            color="success"
        >{{ $t("buttons.close") }}
        </CButton>
      </template>
    </CModal>

  </div>

</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import Vue from "vue";

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
var items_data = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      // show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',
      show_factor_detail: false,
      check_all_exit: false,

      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_template: 0,
      id_checkbox_items: [],
      item_sell_array: [],
      items_buy: [],
      selected_factor: [],

      factor_product_fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'productName', label: this.$t('components.productName'), _style: 'width:10%'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'width:15%'},
        {key: 'price', label: this.$t('tables.amount') , _style: 'width:15%'},
        {key: 'vat', label: this.$t('tables.tax') , _style: 'width:15%'},
        {key: 'discount', label: this.$t('tables.off') , _style: 'width:15%'},
        {key: 'supplierName', label: this.$t('supplierName'), _style: 'width:15%'},
      ],
      fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'createdAt', label: this.$t('submitDate'), _style: 'width:15%'},
        {key: 'masterCode', label:this.$t('orderId'), _style: 'width:10%'},
        {key: 'supplierName', label: this.$t('supplier'), _style: 'width:15%'},

        {key: 'price', label: this.$t('orderAmount'), _style: 'width:15%'},
        // {key: 'select', label: "", _style: 'width:3%', filter: false},
      ],

      table_clicks: 0,
      table_clicks_timer: null,
      details: [],

      status_form: 0,
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', true);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },

    }
  }, mounted() {

    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];

    this.get_all_data();
    bus.$on('update_orders', (data) => {
      this.get_all_data()
    });

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'check_all_exit': function () {
      if (this.check_all_exit) {
        this.id_checkbox_items = [];

        this.items_buy.forEach((val) => {
          this.id_checkbox_items.push(val.MasterId);
        });
      } else {
        this.id_checkbox_items = [];
      }
    },
    '$route.params.person_id': function () {
      // this.get_all_data();
    },
    'start_date': function () {
      this.get_all_data();
    },
    'end_date': function () {
      this.get_all_data();
    }
  },
  methods: {
    get_total_price(item) {
      var total_price = 0
      item.details.forEach((val) => {
        total_price = total_price + (val.price * val.qty)
      });
      return total_price;
    },
    get_all_data() {
      this.get_lists_buy();

    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.selected_factor = item.details;
        this.show_factor_detail = true;
        this.table_clicks = 0

        this.status_form = item.masterId;
      }

    },
    accept_factor() {
      var self = this;


      const formData = new FormData();
      var url = "AddOrderMasterStatus";
      formData.append("StatusId", 1);

      formData.append("OrderMasterId", self.status_form);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.get_lists_buy();
          self.$root.modal_component.show_api_response_modals(response);
self.show_factor_detail = false
          bus.$emit("update_orders", "");

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });


    },
    get_lists_buy() {
      var self = this;


      const formData = new FormData();
      var url = "GetPurchaseOrders";
      formData.append("docType", 1);
      if (self.$route.params.person_id != null) {
        formData.append("PersonId", self.$route.params.person_id);

      } else {
        formData.append("PersonId", 0);
      }
      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.items_buy = content_data.data.map((item, row_id) => {
          //   return {...item, row_id}
          //
          // });
          var factors = content_data.data;
          factors = factors.filter(x => x.isAccept == 0)
          self.items_buy = factors;
          factors.forEach((val) => {
            val.details.forEach((val2) => {

              val2.supplierName = val.supplierName;
              // val2.supplier_list = [{userName: val2.supplierName, userId: val2.supplierId}]
              // self.items_buy.push(val2)
            });
          });

          // setTimeout(() => {
          //   var factors = content_data.data;
          //   factors = factors.filter(x => x.isAccept == 0)
          //   self.items_buy = [];
          //   factors.forEach((val) => {
          //     val.details.forEach((val2) => {
          //
          //       val2.suuplier_sync = true;
          //       val2.supplier_list = [{userName: val2.supplierName, userId: val2.supplierId}]
          //       self.items_buy.push(val2)
          //     });
          //   });


          // }, 1000);

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },

    Finalize(item) {
      var self = this;


      const formData = new FormData();

      var url = "AddFactorToFinal";

      formData.append("id", item.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          item.statusId = 1;
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    send_to_customer(item) {
      var self = this;


      const formData = new FormData();

      var url = "SendFactorToTelegramBoth";

      formData.append("id", item.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          item.statusId = 1;
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    goReturnDocument(item) {
      this.$router.push({
        path: '/dashboard/documents/return/' + item.recId + "/false",
        params: {passed_data: "salam hamidddd"}
      });
    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.recId});
    },
    goPrintDocument(item) {
      bus.$emit("print_confirm", item.recId);


    },
    AddRefer(item) {
      this.submit_refer = item.recId;
    },

    AddAllRefer() {
      this.submit_refer = -1;
      if (this.id_checkbox_items.length == 0) {
        console.log("validate form is false" + this.validate_errors);
        this.submit_refer = 0;

      }
    },

    insert_refer() {
      let self = this;

      if (this.submit_refer != -1) {


        this.id_checkbox_items = [];
      } else {
        if (this.id_checkbox_items.length == 0) {
          console.log("validate form is false" + this.validate_errors);
          self.submit_refer = 0;
          self.id_checkbox_items = [];

          return true;
        }

      }
      if (this.refer_person == null) {
        console.log("validate form is false" + this.validate_errors);

        return true;
      }
      let url;
      // if (this.status_form == 0) {
      url = "AddFactorRefer";
      // }
      if (this.submit_refer != -1) {
        const formData = new FormData();

        formData.append('PersonId', this.refer_person);

        formData.append('MasterFactorId', this.submit_refer);
        axios.post(url, formData, {}).then((res) => {

          self.submit_refer = 0;
          self.id_checkbox_items = [];

          self.refer_person = null;

          self.$root.modal_component.show_api_response_modals(res);
          self.get_all_data()
        })
            .catch(function (error) {

              console.log(error);
            });
      } else {
        self.id_checkbox_items.forEach((val) => {

          const formData = new FormData();

          formData.append('PersonId', this.refer_person);

          formData.append('MasterFactorId', val);
          axios.post(url, formData, {}).then((res) => {

          })
              .catch(function (error) {

                console.log(error);
              });
        });
        self.id_checkbox_items = [];
        self.submit_refer = 0;
        self.id_checkbox_items = [];

        self.refer_person = null;

        this.get_all_data()
      }


    },

  },

}

</script>
